<template>
    <div>
      <CCard>
        <CCardHeader>
          <span
            style="
              font-size: 18px;
              line-height: 24px;
              font-weight: 600;
              color: #3b4859;
            "
            >Upload Catalog</span
          >
       
        </CCardHeader>

        <Upload :map="map" @uploadcb="handlecb"> </Upload>
      </CCard>
    </div>
</template>
<script>
import firebase from "firebase";
import Vue from "vue";
import { uuid } from "vue-uuid";
import Upload from "../components/fileupload";
import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-sugar.css";

Vue.use(VueToast, {
  // One of the options
  position: "top-right",
});


export default {
    components:{
        Upload
    },
  data: () => {
return {
      map: {
        catalog: "Catalogue",
        category: "Category",
        subcategory: "Sub-Category",
        skucode: "SKU No/Product ID",
        product: "Product Name",
        brand: "Brand",
        image: "Image Link",
        description: "Description",
        unit: "Size/Qty",
        mrp: "MRP (Maximum Retail Price)",
        unitprice: "RSP (Retail Selling Price)",
        discount: "% Discount",
        countryoforigin: "Country of Origin",
        mfgdate: "Mfg Date",
        expdate: "Exp Date",
        stock: "Stock Available",
        featured: "Featured Product",
        barcode: "Bar Code",
        stckqty: "Stock Qty",
      },

}
    },
    methods:{
            handlecb(csvvalues) {
      const db = firebase.firestore();
      csvvalues.forEach((doc) => {
        doc["name"] = doc.catalog;
        doc["id"] = firebase.auth().currentUser.uid;
        doc["available"] = true;
        if (
          doc["category"] == "" ||
          doc["catalog"] == "" ||
          doc["subcategory"] == "" ||
          doc["skucode"] == "" ||
          doc["product"] == "" ||
          doc["image"] == "" ||
          doc["description"] == "" ||
          doc["unit"] == "" ||
          doc["mrp"] == "" ||
          doc["unitprice"] == "" ||
          doc["discount"] == "" ||
          doc["featured"] == "" ||
          doc["barcode"] == ""
          // discount,barcode,subcat,image,desc,faetured,
        ) {
          console.log("sdfghjklcfvgbhjnkm");
          Vue.$toast.error("Please enter valid product details", {
            position: "top-right",
          });

          return;
        } else {
          db.collection("catalog")
            .where("id", "==", firebase.auth().currentUser.uid)
            .where("name", "==", doc.catalog)
            .get()
            .then((snapshot) => {
              console.log("length1234", snapshot.docs.length, doc);
              if (snapshot.docs.length == 0) {
                db.collection("catalog").add({
                  available: true,
                  id: firebase.auth().currentUser.uid,
                  image: doc["image"],
                  name: doc["catalog"],
                });

                Vue.$toast.success("Catalog added successfully!", {
                  position: "top-right",
                });
              }
            });
        }
      });
      csvvalues.forEach((doc1) => {
        doc1["name"] = doc1.category;

        doc1["id"] = firebase.auth().currentUser.uid;
        doc1["available"] = true;
        if (
          doc1["category"] == "" ||
          doc1["catalog"] == "" ||
          doc1["subcategory"] == "" ||
          doc1["skucode"] == "" ||
          doc1["product"] == "" ||
          doc1["image"] == "" ||
          doc1["description"] == "" ||
          doc1["unit"] == "" ||
          doc1["mrp"] == "" ||
          doc1["unitprice"] == "" ||
          doc1["discount"] == "" ||
          doc1["featured"] == "" ||
          doc1["barcode"] == ""
        ) {
          console.log("sdfghjklcfvgbhjnkm");
          // Vue.$toast.error("Please enter valid product details", {
          //   position: "top-right",
          // });

          return;
        } else {
          db.collection("category")
            .where("id", "==", firebase.auth().currentUser.uid)
            .where("name", "==", doc1.category)
            .get()
            .then((snapshot) => {
              console.log("length34343", snapshot.docs.length);
              if (snapshot.docs.length == 0) {
                db.collection("category").add({
                  catalog: [doc1["catalog"]],
                  id: firebase.auth().currentUser.uid,
                  image: doc1["image"],
                  name: doc1["name"],
                });
                Vue.$toast.success("Category added successfully!", {
                  position: "top-right",
                });
              }
            });
        }
      });
      csvvalues.forEach((doc2) => {
        doc2["name"] = doc2.name;

        doc2["category"] = doc2.category;
        doc2["catalog"] = doc2.catalog;
        doc2["id"] = firebase.auth().currentUser.uid;
        doc2["available"] = true;
        doc2["image"] = doc2.image;
        doc2["unitprice"] = doc2.unitprice;
        doc2["description"] = doc2.description;
        if (
          doc2["category"] == "" ||
          doc2["catalog"] == "" ||
          doc2["subcategory"] == "" ||
          doc2["skucode"] == "" ||
          doc2["product"] == "" ||
          doc2["image"] == "" ||
          doc2["description"] == "" ||
          doc2["unit"] == "" ||
          doc2["mrp"] == "" ||
          doc2["unitprice"] == "" ||
          doc2["discount"] == "" ||
          doc2["featured"] == "" ||
          doc2["barcode"] == "" 
          
        ) {
          console.log("sdfghjklcfvgbhjnkm");
          // Vue.$toast.error("Please enter valid product details", {
          //   position: "top-right",
          // });

          return;
        } else {
          db.collection("products")
            .where("name", "==", doc2["product"])
            .where("id", "==", firebase.auth().currentUser.uid)
            .get()
            .then((snapshot) => {
              if (snapshot.docs.length == 0) {
                db.collection("products")
                  .add({
                    available: true,
                    barcode: doc2["barcode"],
                    Id: firebase.auth().currentUser.uid,
                    Image: doc2["image"],
                    brand: doc2["brand"],
                    catalog: doc2["catalog"],
                    category: [doc2["category"]],
                    description: doc2["description"],
                    discount: doc2["discount"],
                    enable: true,
                    name: doc2["product"],
                    featured: true,
                    id: firebase.auth().currentUser.uid,
                    image: doc2["image"],
                    skucode: doc2["skucode"],
                    unit: doc2["stock"],
                    unitprice: doc2["unitprice"],
                    mrp: doc2["mrp"],
                    featured: doc2["featured"],
                    // userid:newid,
                    variant: "",
                    variants: "",
                    weight: doc2["unit"],
                  })
                  .then(() => {
                    Vue.$toast.success("Product added successfully!", {
                      position: "top-right",
                    });
                  });

                // db.collection("products").add(doc);
                // });
              }
            });
        }
      });
    },

    }
}
</script>